<!--
 * @Description: 商户审核历史组件
 * @Author: gaohc
 * @Date: 2022-10-14 16:43:52
-->
<template>
  <!-- 	审核状态：0-未审核 1-审核通过  2-审核拒绝 
		3-撤回商户本平台审核状态：20-待审核 21-审核通过 22-审核拒绝 
		23-已撤回商户微信平台审核状态：30-待审核 31-审核中 
		32-待账户验证 33-待签约 34-审核通过 35-审核拒绝 -->
  <div class="review-history-wrap">
    <div style="background-color: transparent" :class=" review.status == 0 ? 'to-be-review'
			: review.status == 2 || review.status == 35 ? 'refuse-text' : 'review-text'">
      <div>
        <div class="header">
          <span class="circle-dot" :class=" review.status == 0 ? 'to-be-review'
						: review.status == 2 || review.status == 35 ? 'refuse-text' : 'review-text'"></span>
          <span>{{ review.statusText }}</span>
          <span v-if="review.status == 1 || review.status == 2" style="margin-left: 26px;">
            审核人： {{ review.reviewerText ? review.reviewerText : '- -' }}
          </span>
        </div>
        <div style="padding-left: 32px">
          <div v-if="review.status == 1 || review.status == 2 || review.status == 35" 
            style="margin-top: 3px">
            <span>{{ review.comment }}</span>
          </div>
          <div class="date-time">
            {{ review.status == 3 ? review.cancelTime : review.reviewTime }}
          </div>
        </div>
      </div>
      <div v-if="review.reviewHistoryList && review.reviewHistoryList.length"
        class="load-more-wrap" @click="showReviewTimeLine = !showReviewTimeLine">
        <div style="margin-right: 5px">
          {{ showReviewTimeLine ? "收起查看" : "展开查看" }}
        </div>
        <i :class=" showReviewTimeLine ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </div>
    </div>
    <div v-if="showReviewTimeLine" class="review-history-timeline">
      <el-timeline>
        <el-timeline-item size="large" v-for="(item, index) in review.reviewHistoryList" 
					:key="index" :color="item.reviewStatus == '2' || item.reviewStatus == '35'
        		? '#FF0909' : '#1BAA60'">
          <div class="review-history-text" :style="{color: item.reviewStatus == '2' 
            || item.reviewStatus == '35' ? '#FF0909' : '#1baa60'}">
            <div>
              <span>{{ item.reviewStatusText }}</span>
              <span v-if="item.reviewStatus == 1 || item.reviewStatus == 2" style="margin-left: 26px;">
                审核人： {{ item.reviewerText ? item.reviewerText : '- -' }}
              </span>
            </div>
            <div v-if="item.comment" style="margin-top: 3px">{{ item.comment }}</div>
            <div style="margin-top: 3px">{{ item.time }}</div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewHistory",
  props: ["review"],
  data() {
    return {
      showReviewTimeLine: false
    }
  }
};
</script>

<style scoped>
.review-history-wrap {
  background: #f7f9fe;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  padding: 20px 40px 20px 30px;
}

.header {
  display: flex;
  align-items: center;
}

.circle-dot {
  display: inline-block;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin-right: 10px;
}

.to-be-review {
  color: #999999;
  background: #d2d8d0;
}

.review-text {
  color: #1baa60;
  background-color: #1baa60;
}

.refuse-text {
  color: #ff0909;
  background-color: #ff0909;
}

.date-time {
  font-size: 13px;
  color: #858585;
  line-height: 18px;
  margin-top: 3px;
}

.load-more-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  line-height: 18px;
  color: #3e7ef5;
}

.load-more-wrap .load-more-icon {
  width: 18px;
  height: 14px;
  margin-right: 4px;
}

.review-history-timeline {
  padding-top: 30px;
}

.review-history-timeline /deep/ .el-timeline-item__node--large {
  height: 22px;
  width: 22px;
}

.review-history-timeline /deep/ .el-timeline-item__tail {
  left: 8px;
  border-left: 3px solid #1baa60;
}

.review-history-text {
  font-size: 14px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/review/components/ReviewHistory.vue